<avi-state-page>
    <avi-state-page_main-content>
        <avi-page-header
            headerText="{{ l10nKeys.headerLabel | vtranslate }}"
            [showEditButton]="isGslbConfigured && gslb.isEditable()"
            [disableClick]="!isGslbConfigured"
            buttonLabelText="{{ globalL10nKeys.editLabel | vtranslate }}"
            buttonToolTip="{{ l10nKeys.editGslbSetting | vtranslate }}"
            (onButtonClick)="openGslbSettingsModal()"
        ></avi-page-header>
        <avi-alert-group
            *ngIf="errors"
            alertType="danger"
            class="gslb-sites-list-page__alert-group"
        >
            {{ errors }}
        </avi-alert-group>

        <div [ngClass]="{ 'gslb-sites-list-page__container': allSitesList.length === 0 }">
            <ng-container *ngIf="allSitesList.length > 0; else noSitesConfiguredTemplate">
                <div
                    class="gslb-sites-list-page__title"
                    [innerHTML]="l10nKeys.gridHeader | vtranslate : replicationModeLabel : allSitesList.length"
                ></div>
                <avi-dynamic-data-grid
                    [config]="gslbSitesGridConfig"
                    [rows]="allSitesList"
                    [rowsTotal]="allSitesList.length"
                    [isLoading]="busy"
                    (onSortingChange)="handleSortingChange($event)"
                >
                    <avi-data-grid_actions *permissionCheck="'PERMISSION_GSLB:WRITE_ACCESS'">
                        <ng-container *ngIf="showCreateButton">
                            <avi-dropdown-button
                                [actions]="createSiteActions"
                                [position]="actionPosition"
                                size="sm"
                            >
                                {{ globalL10nKeys.createLabel | vtranslate }}
                            </avi-dropdown-button>
                        </ng-container>
                    </avi-data-grid_actions>
                </avi-dynamic-data-grid>
            </ng-container>

            <ng-template #noSitesConfiguredTemplate>
                <ng-container *ngIf="busy else noSitesContent">
                    <clr-spinner clrInline></clr-spinner>
                </ng-container>
                <ng-template #noSitesContent>
                    <div class="gslb-sites-list-page__leader-site-container">
                        <div>
                            <img
                                src="src/img/configuration-drift.svg"
                                alt="{{ l10nKeys.createLeaderSiteLabel | vtranslate }}"
                            />
                        </div>
                        <div class="gslb-sites-list-page__leader-site-container-info">
                            <h3>{{ l10nKeys.gslbLabel | vtranslate }}</h3>
                            <p
                                [innerHTML]="l10nKeys.gslbCreateLeaderSiteText | vtranslate : kbLink"
                                class="gslb-sites-list-page__leader-siter-container-paragraph"
                            ></p>
                            <cds-button
                                size="md"
                                (click)="onGslbSiteCreationClick()"
                            >
                                {{ l10nKeys.createLeaderSiteLabel | vtranslate }}
                            </cds-button>
                        </div>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </avi-state-page_main-content>
</avi-state-page>

<ng-template
    #replicationStatusTemplateRef
    let-row
    let-index="index"
>
    <cds-icon
        shape="warning-standard"
        status="warning"
        *ngIf="showWarningIcon(row)"
    ></cds-icon>
    {{ getSyncStateLabel(row) }}
</ng-template>

<ng-template
    #siteNameTemplateRef
    let-row
>
    <div class="gslb-sites-list-page__grid-name-column">
        <avi-tooltip-icon-with-content-wrapper
            shape="circle"
            size="18"
            [status]="row.runtime.site_info.oper_status.state | operationalStateIconStatus"
            [solid]="true"
        >
            {{ row.runtime.site_info.oper_status.reason.join() }}
        </avi-tooltip-icon-with-content-wrapper>
        <div *ngrxLet="localClusterId$ as localClusterId">
            <span>{{ row.config.config.name }}</span>
            <span *ngIf="localClusterId === row.config.config.cluster_uuid">
                ({{ l10nKeys.currentLabel | vtranslate }})
            </span>
        </div>
    </div>
</ng-template>

<ng-template
    #dnsVsTemplateRef
    let-row
>
    <ng-container *ngIf="getDnsVsNames(row.runtime.site_info.dns_info) as data; else notApplicableTempateRef">
        <ng-container *ngTemplateOutlet="valuewithColumnSuffixTemplateRef; context: { $implicit: data }"></ng-container>
    </ng-container>
</ng-template>

<ng-template
    #ipAddrTemplateRef
    let-row
>
    <!-- Third-party sites using GslbThirdPartySiteConfigItems do not have the ipAddress method. -->
    <ng-container *ngIf="row.config.ipAddress?.() as data; else notApplicableTempateRef">
        <ng-container *ngTemplateOutlet="valuewithColumnSuffixTemplateRef; context: { $implicit: data }"></ng-container>
    </ng-container>
</ng-template>

<ng-template
    #valuewithColumnSuffixTemplateRef
    let-data
>
    <span>{{ data?.[0] || '-' }}</span>
    <!-- To show '+ more' message and tooltip for remaining values -->
    <span
        *ngIf="data.length > 1"
        aviTitle="{{ data.slice(1) }}"
    >
        {{ l10nKeys.columnValueSuffix | vtranslate : data.length - 1  }}
    </span>
</ng-template>

<ng-template #notApplicableTempateRef>
    {{ globalL10nKeys.notApplicableLabel | vtranslate }}
</ng-template>
